import { default as MuiTooltip, TooltipProps } from '@material-ui/core/Tooltip';
import { ChangeEvent } from 'react';
import { useMaxZIndex } from 'hooks/useMaxZIndex';

export interface ITooltipProps {
  title: JSX.Element;
  children: React.ReactElement;
  placement?: TooltipProps['placement'];
  onOpen?: (event: ChangeEvent<{}>) => void;
}

export function Tooltip({ title, children, placement, onOpen }: ITooltipProps) {
  const { zIndex } = useMaxZIndex();

  return (
    <MuiTooltip
      title={title}
      placement={placement}
      interactive
      arrow
      onOpen={onOpen}
      PopperProps={{style:{zIndex}}}
      classes={{ tooltip: 'dp-tooltip', arrow: 'dp-tooltip__arrow' } as any}
    >
      {children}
    </MuiTooltip>
  );
}
